<template>
  <form class="message-form">
    <v-textarea
      class="message-form__textarea"
      label="Message text"
      v-model="text"
      no-resize
      outlined
      rows="3"
      row-height="25"
      shaped
      counter
    />
    <v-btn
      @click="sendSms"
      :disabled="text.trim() === ''"
      class="message-form__button"
      large
      outlined
      color="primary"
    >
      Send message
    </v-btn>
  </form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "TextForm",
  data() {
    return {
      text: "",
    };
  },
  methods: {
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),
    sendSms() {
      if (!this.lead.phone) {
        this.showHandlerSnackbar({
          color: "error",
          text: "Lead phone is not exist!",
          show: true,
        });

        return false;
      }

      if (this.text.trim() !== "") {
        this.$axios
          .post("message/send", {
            lead_id: this.lead.id,
            user_id: this.user.id,
            text: this.text,
            to: this.lead.phone,
          })
          .then((res) => {
            this.showHandlerSnackbar({
              color: res.data.status,
              text: res.data.message,
              show: true,
            });
          })
          .catch((e) => {
            this.showHandlerSnackbar({
              color: e.response.data.status,
              text: e.response.data.message,
              show: true,
            });
          });
      } else {
        this.showHandlerSnackbar({
          color: "error",
          text: "Cannot send empty message",
          show: true,
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      lead: "lead/lead",
      user: "auth/user",
    }),
  },
};
</script>

<style>
</style>